import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './en';
import ja from './ja';
import zhTW from './zh-tw';
import zhCN from './zh-cn';
import de from './de';
import fr from './fr';
import es from './es';
import vi from './vi';
import tr from './tr';
import ko from './ko';
import it from './it';
import ptBR from './pt-br';
import ro from './ro';

Vue.use(VueI18n);

let lang;
if (localStorage) {
  lang = localStorage.getItem('locale');
}
lang = lang || navigator.language.toLowerCase();

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: lang, // set locale
  fallbackLocale: 'en',
  messages: {
    ja,
    fr,
    de,
    es,
    en,
    vi,
    tr,
    ko,
    it,
    ro,
    zh: zhTW,
    cn: zhCN,
    pt: ptBR,
    'en-us': en,
    'zh-tw': zhTW,
    'zh-cn': zhCN,
    'tr-tr': tr,
    'vi-vn': vi,
    'pt-br': ptBR,
    'ro-ro': ro,
  },
});

export default i18n;
